import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({ providedIn: 'root' })
export class RecaptchaLoaderService {
  private scriptId = 'recaptcha-script';
  private containerSelector = '.recaptcha-login';
  private googleScriptUrl = AppConfigService.recaptchaGoogleScript;

  load(lang: string): void {
    // 1. Eliminar script existente
    const existingScript = document.getElementById(this.scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    // 2. Eliminar cualquier iframe/div ya renderizado del captcha
    const container = document.querySelector(this.containerSelector);
    if (container) {
      container.innerHTML = ''; // borra el captcha previo
    }

    // 3. Inyectar script nuevo con idioma
    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = this.googleScriptUrl + '?' + `hl=${lang}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
}
